import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/submissions";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name || u.email}`);
      if (u.role === "admin") navigate("/admin");
      else navigate(next);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <Header />
      <div className="rgu-container py-20 grid grid-cols-1 md:grid-cols-12 gap-12 max-w-4xl">
        <div className="md:col-span-5">
          <div className="rgu-eyebrow text-slate-500 mb-3">Account · Access</div>
          <h1 className="font-display text-3xl md:text-4xl text-[#0A192F]">Sign in to RGU.</h1>
          <p className="mt-4 text-slate-600">Track submissions, receive status updates, and access exclusive offers from our authentication team.</p>
        </div>
        <form onSubmit={onSubmit} className="md:col-span-7 border border-slate-200 p-8 space-y-5" data-testid="login-form">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-none" />
          </div>
          <div>
            <div className="flex items-center justify-between">
              <Label htmlFor="password">Password</Label>
              <Link to="/forgot-password" className="text-xs font-mono-rgu uppercase tracking-widest text-slate-500 hover:text-[#0A192F] hover:underline" data-testid="login-forgot-link">
                Forgot?
              </Link>
            </div>
            <Input id="password" data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 rounded-none" />
          </div>
          <button type="submit" disabled={loading} className="rgu-btn-primary w-full justify-center text-xs uppercase tracking-widest" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-sm text-slate-500 pt-2">
            New to RGU? <Link to="/signup" className="text-[#0A192F] underline" data-testid="login-signup-link">Create an account</Link>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
}
